import enUS from './en-US';
import ja from './ja';

export default {
  'en-US': enUS,
  'ja': ja
};
